<template>
  <div class="DeviceInfo">
    <div class="ptmember-cbj">
      <div class="ptmember-center">
        <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true>
           <!-- <el-tab-pane label="账号密码登录" name="second"> -->
              <el-form ref="form" :model="form" :rules="rules" label-width="60px">
                <el-form-item label="账号" prop="tel">
                  <el-input placeholder="请输入账号/手机号" v-model.number="form.tel"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                  <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
                </el-form-item>
                <el-form-item style="margin-left: 0;">
                  <el-button type="warning" @click="onSubmit(form)" size="medium" style=" width: 24%;">登录</el-button>
                  <p class="pt-bottom">
                    <!-- <router-link  :to="{path:'Login?ptzc=1'}" >立即注册</router-link> -->
                    <!-- <router-link  :to="`Register`" >立即注册</router-link> -->
                    <!-- <span @click="$emit('setPtzc')">立即注册</span> -->
                    <!-- <router-link  :to="{path:'Forgetpass'}" >忘记密码</router-link> -->
                  </p>
                </el-form-item>
              </el-form>
           </el-tab-pane>
        <!--   <el-tab-pane label="验证码登录" name="third">
            <div class="root">
              <el-form :model="Register" ref="RegisterForm" :rules="Registerrules" class="RegisterForm" label-width="80px">
                  <el-form-item label="手机号" prop="tel">
                      <el-input v-model.number="Register.tel" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                  <el-form-item label="验证码" prop="验证码" class="code">
                      <el-input v-model="Register.sendcode" placeholder="请输入验证码"></el-input>
                      <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==false">发送验证码</el-button>
                      <el-button type="button" @click="sendcode" :disabled="disabled" v-if="disabled==true">{{btntxt}}</el-button>
                  </el-form-item>
                  <el-form-item>
                      <el-button type="primary" @click="submitForm(Register)" size="medium">登录</el-button>
                  </el-form-item>
              </el-form>
            </div>
          </el-tab-pane> -->
         </el-tabs>
       </div>
     </div>
   </div>
</template>
<style scoped >
    .DeviceInfo >>> .el-tabs__item {font-size: 14px;}
    .DeviceInfo >>> .el-tabs__active-bar{width: 0 !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;}
    .DeviceInfo >>> .ptmember-center .el-tabs__nav-wrap::after{background-color:#ffffff !important;;}
    .DeviceInfo >>> .el-tabs__nav-scroll{width: 84%;float: right;}
    /* .DeviceInfo >>> .el-button--medium{width: 100%;background: #2c7ac1;border-color: #2c7ac1;} */


    .DeviceInfo >>> .root {width:100vw;display: table-cell;vertical-align: middle;}
    .DeviceInfo >>> .root  form {width: 100%;margin: auto;}
    .DeviceInfo >>> .root  form .code .el-input{width: 66%;border-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-button {background: #f5f7fa;width: 34%;border-top-left-radius: 0px;border-bottom-left-radius: 0px;float: left;display: inline-block;}
    .DeviceInfo >>> .root  form .code .el-input .el-input__inner{border-top-right-radius: 0px;border-bottom-right-radius: 0px;}

</style>
<script>
export default{
  data(){
    return {
      activeName: 'second',
      name: "Register",
      form: {
          tel: '',
          password:'',
      },
      rules: {
        tel: [
          { required: true, message: '请输入账号', trigger: 'blur' },
        ],
      },
      Registerrules:{
        tel: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
        ],
      },
      Register: {
          tel: '',
          sendcode: '',
      },
      disabled: false,
      time: 0,
      btntxt: "重新发送",
    }
  },
  mounted () {
    var that = this;
    // that.$api.post("/Upload/uploadcorda",{}).then(res => {
    //   console.log(res);
    // });
  },
  methods:{

    // 选项卡切换
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 密码登录提交
    onSubmit(form) {
      console.log(form);
      let password = form.password;
      if(form.tel == ''){
        this.$message.error('请输入手机号');
        return
      }
      if(form.password == ''){
        this.$message.error('请输入密码');
        return
      }
      var that = this
      that.$api.post("/Login/login",{'tel':form.tel,'password':form.password}).then(res => {
        console.log(res);
        if(res.code==1){


          this.$cookieStore.setCookie( 'userid' ,this.$encruption(res.userid.toString()), 360000);
          this.$message({
            message: res.msg,
            type: 'success'
          });
          setTimeout(this.$router.push('/Index?index=1'), 1000);
          }
      });

    },
    // 验证码登录
    submitForm(Register){
      console.log(Register);

      var that = this;
      var yzms =  this.$cookieStore.getCookie('yzms');  // 获取返回来的验证码
      if(Register.sendcode==''){
        this.$message.error('验证码不能为空');
        return
      }
      if(Register.yzms==''){
        this.$message.error('验证码已过期');
        return
      }
      if(Register.sendcode===yzms){
          console.log(yzms);
          that.$api.post("/Login/passlogin",{'tel':Register.tel,'openid':''}).then(res => {
            console.log(res);
            if(res.code==1){
              this.$cookieStore.setCookie( 'userid' ,res.userid, 360000);
              this.$message({
                message: res.msg,
                type: 'success'
              });
              setTimeout(this.$router.push('/'), 1000);
              }
          });
      }else{
        this.$message.error('请输入正确验证码');
        return
      }


    },
    //手机验证发送验证码
    sendcode() {
      var that = this;
        const reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
        if (this.Register.tel == '') {
           this.$message.error('手机号不能为空');
           return
        }
        if (!reg.test(this.Register.tel)) {
              this.$message.error('请输入正确的手机号');
            return
        } else {
            console.log();

            that.$api.post("/upload/dlyzm",{'tel':this.Register.tel}).then(res => {
                console.log(res);
                 if(res.code == 1){
                   this.$message({
                       message: '发送成功',
                       type: 'success',
                   });
                   this.time = 60;
                   this.disabled = true;
                   this.timer();
                 }else{
                   this.$message.error('发送失败');
                 }
                 this.$cookieStore.setCookie( 'yzms' ,res.msg, 61);
            })
        }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
          this.time--;
          this.btntxt = this.time + "s后重新获取";
          setTimeout(this.timer, 1000);
      } else {
          this.time = 0;
          this.btntxt = "获取验证码";
          this.disabled = false;
      }
    },





  },
 }
</script>



// WEBPACK FOOTER //
// src/components/login/ptmember.vue